// `text` stays untranslated: it is persisted/compared as the perk's `category`
// value against server data (see PerksForm submit + NeighborhoodPerks filter),
// not just display copy. `key` is the matching key in neighborhood-perks.json
// `categories`, used only where these entries are rendered as display text.
const categories = [
  { id: 1, key: 'restaurantsAndBars', text: 'Restaurants and Bars' },
  { id: 2, key: 'nightlife', text: 'Nightlife' },
  { id: 3, key: 'services', text: 'Services' },
  { id: 4, key: 'fitnessStudios', text: 'Fitness Studios' },
  { id: 5, key: 'gymMemberships', text: 'Gym Memberships' },
  { id: 6, key: 'beautyAndSpa', text: 'Beauty & Spa' },
  { id: 7, key: 'artsAndEntertainment', text: 'Arts & Entertainment' },
  { id: 8, key: 'petServices', text: 'Pet Services' },
  { id: 9, key: 'hotels', text: 'Hotels' },
  { id: 10, key: 'transportationServices', text: 'Transportation Services' },
  { id: 11, key: 'breakfastAndCoffee', text: 'Breakfast and Coffee' },
]

export default categories
